import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ExperienceRoutingModule } from './pages/experience/experience-routing.module';

const routes: Routes = [
    // Introduction Phase
    {
        path: '',
        loadChildren: () => import('./pages/introduction/landing/landing.module').then(m => m.LandingPageModule)
    },
    {
        path: 'splash',
        loadChildren: () => import('./pages/introduction/splash/splash.module').then(m => m.SplashPageModule)
    },
    // Experience Phase
    // {
    //     path: 'register',
    //     loadChildren: () => import('./pages/experience/chrome/register/register.module').then(m => m.RegisterPageModule)
    // },
    // {
    //     path: 'login',
    //     loadChildren: () => import('./pages/experience/chrome/login/login.module').then(m => m.LoginPageModule)
    // },
    // {
    //     path: 'lvb-media-screens',
    //     loadChildren: () => import('./pages/experience/lvb-media-screens/lvb-media-screens.module').then(m => m.LvbMediaScreensPageModule)
    // },
    // {
    //     path: 'lvb-media-screens',
    //     loadChildren: () => import('./pages/experience/lvb-media-screens/lvb-media-screens.module').then(m => m.LvbMediaScreensPageModule),
    //     outlet: 'mobile'
    // },
    // {
    //     path: 'messages',
    //     loadChildren: () => import('./pages/experience/messages/messages/messages.module').then(m => m.MessagesPageModule)
    // },
    // {
    //     path: 'messages',
    //     loadChildren: () => import('./pages/experience/messages/messages/messages.module').then(m => m.MessagesPageModule),
    //     outlet: 'mobile'
    // },
    // {
    //     path: 'message-details',
    //     loadChildren: () => import('./pages/experience/messages/message-details/message-details.module').then(m => m.MessageDetailsPageModule)
    // },
    // {
    //     path: 'message-details',
    //     loadChildren: () => import('./pages/experience/messages/message-details/message-details.module').then(m => m.MessageDetailsPageModule),
    //     outlet: 'mobile'
    // },
    // {
    //     path: 'mails',
    //     loadChildren: () => import('./pages/experience/mails/mails/mails.module').then(m => m.MailsPageModule),
    //     outlet: 'mobile'
    // },
    // {
    //     path: 'mails',
    //     loadChildren: () => import('./pages/experience/mails/mails/mails.module').then(m => m.MailsPageModule)
    // },
    // {
    //     path: 'mail-details/:id',
    //     loadChildren: () => import('./pages/experience/mails/mail-details/mail-details.module').then(m => m.MailDetailsPageModule),
    //     outlet: 'mobile'
    // },
    // {
    //     path: 'mail-details/:id',
    //     loadChildren: () => import('./pages/experience/mails/mail-details/mail-details.module').then(m => m.MailDetailsPageModule)
    // },
    // {
    //     path: 'site-simulation',
    //     loadChildren: () => import('./pages/experience/chrome/site-simulation/site-simulation.module').then(m => m.SiteSimulationPageModule)
    // },
    // {
    //     path: 'create-account',
    //     loadChildren: () => import('./pages/experience/chrome/create-account/create-account.module').then(m => m.CreateAccountPageModule)
    // },
    // {
    //     path: 'contact',
    //     loadChildren: () => import('./pages/experience/chrome/contact/contact.module').then(m => m.ContactPageModule)
    // },
    // {
    //     path: 'verification-modal',
    //     loadChildren: () => import('./modals/verification-modal/verification-modal.module').then(m => m.VerificationModalPageModule)
    // },
    // {
    //     path: 'enter-validation-code',
    //     loadChildren: () => import('./pages/experience/chrome/enter-validation-code/enter-validation-code.module').then(m => m.EnterValidationCodePageModule)
    // },
    // {
    //     path: 'mail-validation',
    //     loadChildren: () => import('./pages/experience/chrome/mail-validation/mail-validation.module').then(m => m.MailValidationPageModule)
    // },
    // {
    //     path: 'forgot-password',
    //     loadChildren: () => import('./pages/experience/chrome/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
    // },
    // {
    //     path: 'account-created',
    //     loadChildren: () => import('./pages/experience/chrome/account-created/account-created.module').then(m => m.AccountCreatedPageModule)
    // },
    // {
    //     path: 'activate',
    //     loadChildren: () => import('./pages/experience/chrome/activate/activate.module').then(m => m.ActivatePageModule)
    // },
    // {
    //     path: 'forget-mail-send',
    //     loadChildren: () => import('./pages/experience/chrome/forget-mail-send/forget-mail-send.module').then(m => m.ForgetMailSendPageModule)
    // },
    // {
    //     path: 'new-password',
    //     loadChildren: () => import('./pages/experience/chrome/new-password/new-password.module').then(m => m.NewPasswordPageModule)
    // },
    // Reflection Phase
    {
        path: 'reflection',
        loadChildren: () => import('./pages/reflection/reflection.module').then(m => m.ReflectionModule)
    },
    // Learning Phase
    {
        path: 'learning',
        loadChildren: () => import('./pages/learning/learning.module').then(m => m.LearningModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            {
                enableTracing: false,
                preloadingStrategy: PreloadAllModules
            }
        ),
        ExperienceRoutingModule
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
